// import Swiper bundle with all modules installed FULLと軽量のものがある
import Swiper from "swiper/bundle";
// import Swiper, { Navigation, Pagination } from "swiper";
// import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
// Swiper.use([Navigation, Pagination]);
// Swiper.use([Autoplay, Navigation, Pagination]);

export function swiper() {
  // Initialize Swiper
  let swiper_pc = new Swiper(".swiper-container-pc", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  let swiper_sp = new Swiper(".swiper-container-sp", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  let swiper_profile = new Swiper(".swiper-profile", {
    centeredSlides: true,
    slidesPerView: 1.5,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 3000,
    // },
    // loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // 店舗案内のサムネイル
  let swiper_tree = new Swiper(".swiper-tree", {
    slidesPerView: 1,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    noSwiping: true,
    allowTouchMove: false,
    freeMode: true,
  });

  // 店舗案内のスライダー
  let swiper_honten = new Swiper(".swiper-honten", {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
    },
    paginationClickable: true,
    speed: 1000,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    loop: true,
    thumbs: {
      swiper: swiper_tree,
    },
  });
  let swiper_menu = new Swiper(".swiper-menu", {
    slidesPerView: "auto",
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
  });
}
